// External libraries
import { defaultDataIdFromObject, InMemoryCache } from 'apollo-cache-inmemory';

export const cache = new InMemoryCache({
  dataIdFromObject: object => {
    if (object.__typename === 'CheckoutSession') {
      return object.__typename;
    }
    return defaultDataIdFromObject(object);
  },
});
